import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; 

export default function ExternalLinks() {
  const { t } = useTranslation();

  // ข้อมูลสำหรับแบนเนอร์ (แยกประเภทลิงก์ภายนอกและภายใน)
  const externalLinks = [
    { 
      name: "หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่", 
      banner: "/icons/1.png", // แก้ไขที่เก็บรูปแบนเนอร์ของคุณที่นี่
      url: "https://www.finearts.go.th/chiangmailibrary/categorie/dept-ebook", // URL จริงของเว็บ
      isExternal: true 
    },
    { 
      name: "ฐานข้อมูลเอกสารโบราณ จารึก สมุดไทย ตู้พระธรรมและคัมภีร์ใบลาน สำนักหอสมุดแห่งชาติ", 
      banner: "/icons/2.jpg", // แก้ไขที่เก็บรูปแบนเนอร์ของคุณที่นี่
      url: "https://manuscript.nlt.go.th/%E0%B8%AA%E0%B8%B7%E0%B8%9A%E0%B8%84%E0%B9%89%E0%B8%99", 
      isExternal: true 
    },
    { 
      name: "ห้องสมุดดิจิทัล หอสมุดแห่งชาติ", 
      banner: "/icons/3.png", 
      url: "https://mobile.nlt.go.th/", 
      isExternal: true 
    },
    { 
      name: "D-Library ห้องสมุดดิจิทัล : คลังข้อมูลมรดกภูมิปัญญาของชาติ สำนักหอสมุดแห่งชาติ", 
      banner: "/icons/4.png", 
      url: "http://digital.nlt.go.th/dlib/", 
      isExternal: true 
    },
    { 
      name: "ระบบคลังข้อมูลดิจิทัล กรมศิลปากร กระทรวงวัฒนธรรม", 
      banner: "/icons/5.png", 
      url: "https://digitalcenter.finearts.go.th/home", 
      isExternal: true 
    },
    { 
      name: "ฐานข้อมูลอื่นๆ", 
      banner: "/icons/12.png", 
      url: "/portal", // ลิงก์ภายในเพื่อไปหน้า WebPortal.jsx
      isExternal: false 
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-[#e5d7ca] p-5 shadow-sm">
      <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
        <span className="w-2 h-6 bg-[#5b4a3e] rounded-full"></span>
        {t("home.externalDB", "ฐานข้อมูลเอกสารโบราณและหนังสือหายาก")}
      </h3>
      
      {/* เปลี่ยนมาใช้ flex-col เพื่อให้เรียงแบนเนอร์ลงมาในแนวดิ่ง */}
      <div className="flex flex-col gap-4">
        {externalLinks.map((link, idx) => {
          // สไตล์พื้นฐานของกล่องแบนเนอร์
          const bannerClasses = "block w-full rounded-xl overflow-hidden border border-[#e5d7ca] hover:border-[#d8653b] hover:shadow-md transition-all group";
          
          // เนื้อหาด้านในกล่อง (แยกเป็นตัวแปรเพื่อใช้ซ้ำทั้งใน <a> และ <Link>)
          const bannerContent = (
            <div className="flex flex-col relative bg-[#fcfaf8]">
              {/* ส่วนรูปภาพ กำหนดสัดส่วนแนวยาว (เช่น 4:1 หรือ 21:9) */}
              <div className="w-full aspect-[21/9] sm:aspect-[4/1] flex items-center justify-center overflow-hidden">
                <img 
                  src={link.banner} 
                  alt={link.name} 
                  // หากต้องการให้รูปภาพพอดีเป๊ะโดยไม่โดนครอป ให้เปลี่ยน object-cover เป็น object-contain
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" 
                />
              </div>
              
              {/* แถบชื่อกำกับด้านล่างแบนเนอร์ */}
              <div className="p-2 text-center border-t border-[#e5d7ca] group-hover:bg-[#f1e6da] transition-colors">
                <span className="text-xs sm:text-sm font-medium text-[#3d342e] group-hover:text-[#d8653b] leading-tight">
                  {link.name}
                </span>
              </div>
            </div>
          );

          // เช็คว่าเป็นลิงก์ภายนอกหรือไม่
          if (link.isExternal) {
            return (
              <a 
                key={idx} 
                href={link.url} 
                target="_blank" // เปิดหน้าใหม่
                rel="noopener noreferrer" // เพิ่มความปลอดภัยเมื่อใช้ target="_blank"
                className={bannerClasses}
              >
                {bannerContent}
              </a>
            );
          }

          // ถ้าเป็นลิงก์ภายใน (ไปยังหน้า WebPortal.jsx)
          return (
            <Link 
              key={idx} 
              to={link.url} 
              className={bannerClasses}
            >
              {bannerContent}
            </Link>
          );
        })}
      </div>
    </div>
  );
}